<template>
  <lazy-component tag="div" class="instagram-lazy-wrapper" ref="lazy">
    <div v-html="item.content.html"></div>
  </lazy-component>
</template>
<script>
import has from 'lodash/has'
import get from 'lodash/get'

export default {
  name: 'body-instagram',
  props: ['item'],
  mounted() {
    this.$watch('$refs.lazy.state.loaded', () => {
      if (get(this, '$refs.lazy.state.loaded')) {
        if (has(window, 'instgrm.Embeds.process')) {
          window.instgrm.Embeds.process()
        } else if (!has(window, 'instgrm')) {
          /* eslint-disable */
          (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0],
              t = window.instgrm || {};
            if (d.getElementById(id)) return t;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://platform.instagram.com/en_US/embeds.js";
            fjs.parentNode.insertBefore(js, fjs);
            return t;
          }(document, "script", "instgrm-scr"));
          /* eslint-enable */
        }
      }
    })
  },
}
</script>



// WEBPACK FOOTER //
// Instagram.vue?7597f53a